import { render, staticRenderFns } from "./requestOnGoing.vue?vue&type=template&id=fc7252e6&scoped=true&"
import script from "./requestOnGoing.vue?vue&type=script&lang=js&"
export * from "./requestOnGoing.vue?vue&type=script&lang=js&"
import style0 from "./requestOnGoing.vue?vue&type=style&index=0&id=fc7252e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc7252e6",
  null
  
)

export default component.exports